var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "900",
        "content-class": "dialog-galleria-calciatori",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-galleria-calciatori-card navy darken-2" },
        [
          _c(
            "div",
            {
              staticClass:
                "dialog-galleria-calciatori-header navy darken-3 white--text",
            },
            [
              _c("div", { staticClass: "dialog-galleria-calciatori-heading" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "dialog-galleria-calciatori-title font-hemi-head",
                  },
                  [_vm._v("\n          GALLERIA CALCIATORI\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dialog-galleria-calciatori-subtitle" },
                  [
                    _vm._v(
                      "\n          Questa galleria non serve assolutamente a niente durante l'asta. Ma i nuovi\n          avatar meritavano di essere visualizzati piú grandi :)\n          "
                    ),
                    _c("br"),
                    _vm._v(
                      "PS: Stiamo\n          provvedendo ad aggiornare tutti gli avatar: abbi ancora un po' di\n          pazienza, per favore.\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", "aria-label": "Chiudi galleria" },
                  on: { click: _vm.dismiss },
                },
                [
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("close"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-galleria-calciatori-filters navy darken-2" },
            [
              _c(
                "div",
                {
                  staticClass: "dialog-galleria-calciatori-role-filters",
                  attrs: { "aria-label": "Filtra per ruolo" },
                },
                _vm._l(_vm.Constants.RUOLO, function (ruoloId) {
                  var _obj
                  return _c(
                    "v-btn",
                    {
                      key: ruoloId,
                      attrs: {
                        icon: "",
                        small: "",
                        "aria-pressed": _vm.selectedRuoli.includes(ruoloId),
                        "aria-label":
                          "Filtra " + _vm.Constants.RUOLI_NEW[ruoloId].plurale,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleRuolo(ruoloId)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "Ruolo",
                          class:
                            ((_obj = {}),
                            (_obj["Ruolo_" + ruoloId] = true),
                            (_obj.outline =
                              !_vm.selectedRuoli.includes(ruoloId)),
                            (_obj.selezionato =
                              _vm.selectedRuoli.includes(ruoloId)),
                            _obj),
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.Constants.RUOLI[ruoloId]) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "dialog-galleria-calciatori-search",
                attrs: {
                  label: "Cerca per nome",
                  "prepend-inner-icon": "search",
                  clearable: "",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.searchNome,
                  callback: function ($$v) {
                    _vm.searchNome = $$v
                  },
                  expression: "searchNome",
                },
              }),
              _vm._v(" "),
              _c("v-select", {
                staticClass: "dialog-galleria-calciatori-club",
                attrs: {
                  items: _vm.clubOptions,
                  label: "Club",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.selectedClub,
                  callback: function ($$v) {
                    _vm.selectedClub = $$v
                  },
                  expression: "selectedClub",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-galleria-calciatori-content" },
            [
              _vm.calciatoriGallery.length
                ? _c(
                    "v-carousel",
                    {
                      key: _vm.galleryCarouselKey,
                      staticClass: "dialog-galleria-calciatori-carousel",
                      attrs: {
                        height: "100%",
                        "hide-delimiters": "",
                        continuous: false,
                        cycle: false,
                      },
                      model: {
                        value: _vm.activeIndex,
                        callback: function ($$v) {
                          _vm.activeIndex = $$v
                        },
                        expression: "activeIndex",
                      },
                    },
                    _vm._l(_vm.calciatoriGallery, function (calciatore) {
                      return _c(
                        "v-carousel-item",
                        { key: calciatore.id || calciatore.nid },
                        [
                          _c(
                            "div",
                            { staticClass: "dialog-galleria-calciatori-slide" },
                            [
                              _c("calciatore-gallery", {
                                attrs: {
                                  calciatore: calciatore,
                                  mantra: _vm.mantra,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.calciatoriGallery.length
                ? _c(
                    "div",
                    { staticClass: "dialog-galleria-calciatori-counter" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.activeIndex + 1) +
                          " / " +
                          _vm._s(_vm.calciatoriGallery.length) +
                          "\n      "
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "dialog-galleria-calciatori-empty white--text text-center",
                    },
                    [
                      _vm._v(
                        "\n        Nessun calciatore trovato (nel ruolo/i selezionati).\n      "
                      ),
                    ]
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }